import React from "react";
import { Platform, View } from "react-native";
import FastImage, { FastImageProps, Source } from "@d11/react-native-fast-image";


interface ImageWithAspectRatioProps {
    aspectRatio: number,
    minHeight?: number,
    source: Source
    minWidth?: number,
    imageProps?: FastImageProps
}

const ImageWithAspectRatio: React.FC<ImageWithAspectRatioProps> = ({ aspectRatio, imageProps, minHeight, minWidth, source }) => {

    return (
        <View style={[{ aspectRatio: aspectRatio }, minWidth ? { minWidth } : {}, minHeight ? { minHeight } : {}]}>
            <FastImage source={source}
                resizeMode='contain'
                style={{
                    flex: 1,
                    ...(Platform.OS === 'web' && {
                        imageRendering: 'high-quality',
                    }),
                }}

                {...imageProps}
            />
        </View>
    )
}

export default ImageWithAspectRatio